import React, { useState } from 'react';
import { Container } from '../components/ui/Container';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
import { Mail, MessageSquare, Phone } from 'lucide-react';
export function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="bg-white" data-id="element-260">
      {/* Hero */}
      <div className="bg-gray-900 py-20 lg:py-32 text-center text-white" data-id="element-261">
        <Container data-id="element-262">
          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl mb-6" data-id="element-263">
            Get in Touch
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-264">
            Have questions? We'd love to hear from you. Send us a message and
            we'll respond as soon as possible.
          </p>
        </Container>
      </div>

      {/* Contact Form & Info */}
      <section className="py-24" data-id="element-265">
        <Container data-id="element-266">
          <div className="grid lg:grid-cols-2 gap-16" data-id="element-267">
            {/* Contact Info */}
            <div data-id="element-268">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-269">
                Contact Information
              </h2>
              <p className="text-gray-600 mb-8" data-id="element-270">
                Reach out to us through any of these channels, and we'll get
                back to you within 24 hours.
              </p>

              <div className="space-y-6" data-id="element-271">
                <div className="flex items-start" data-id="element-272">
                  <div className="flex-shrink-0" data-id="element-273">
                    <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600" data-id="element-274">
                      <Mail className="h-6 w-6 text-white" data-id="element-275" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-276">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-277">Email</h3>
                    <p className="mt-1 text-gray-600" data-id="element-278">info@acciom.co.uk</p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-279">
                  <div className="flex-shrink-0" data-id="element-280">
                    <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600" data-id="element-281">
                      <MessageSquare className="h-6 w-6 text-white" data-id="element-282" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-283">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-284">
                      Live Chat
                    </h3>
                    <p className="mt-1 text-gray-600" data-id="element-285">
                      Available Mon-Fri, 9am-5pm GMT
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-286">
                  <div className="flex-shrink-0" data-id="element-287">
                    <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600" data-id="element-288">
                      <Phone className="h-6 w-6 text-white" data-id="element-289" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-290">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-291">
                      Support
                    </h3>
                    <p className="mt-1 text-gray-600" data-id="element-292">
                      Priority support for Pro & Agency plans
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-12 p-6 bg-gray-50 rounded-lg" data-id="element-293">
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-294">
                  Flowsense by Acciom Limited
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-295">
                  We're committed to helping brands optimize their email
                  marketing flows with AI-powered insights.
                </p>
              </div>
            </div>

            {/* Contact Form */}
            <div data-id="element-296">
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-297">
                <div data-id="element-298">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-299">
                    Name
                  </label>
                  <Input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required placeholder="Your name" data-id="element-300" />
                </div>

                <div data-id="element-301">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-302">
                    Email
                  </label>
                  <Input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required placeholder="your@email.com" data-id="element-303" />
                </div>

                <div data-id="element-304">
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-305">
                    Subject
                  </label>
                  <Input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required placeholder="How can we help?" data-id="element-306" />
                </div>

                <div data-id="element-307">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-308">
                    Message
                  </label>
                  <textarea id="message" name="message" rows={6} value={formData.message} onChange={handleChange} required placeholder="Tell us more about your question or feedback..." className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" data-id="element-309" />
                </div>

                <Button type="submit" size="lg" className="w-full" noGradient data-id="element-310">
                  Send Message
                </Button>
              </form>
            </div>
          </div>
        </Container>
      </section>
    </div>;
}